(() => {
function $cd63440b1507af0d$var$initMarqueeScrollDirection() {
    document.querySelectorAll("[data-marquee-scroll-direction-target]").forEach((marquee)=>{
        // Query marquee elements
        const marqueeContent = marquee.querySelector("[data-marquee-collection-target]");
        const marqueeScroll = marquee.querySelector("[data-marquee-scroll-target]");
        if (!marqueeContent || !marqueeScroll) return;
        // Get data attributes
        const { marqueeSpeed: speed, marqueeDirection: direction, marqueeDuplicate: duplicate, marqueeScrollSpeed: scrollSpeed } = marquee.dataset;
        // Convert data attributes to usable types
        const marqueeSpeedAttr = parseFloat(speed);
        const marqueeDirectionAttr = direction === "right" ? 1 : -1; // 1 for right, -1 for left
        const duplicateAmount = parseInt(duplicate || 0);
        const scrollSpeedAttr = parseFloat(scrollSpeed);
        const speedMultiplier = window.innerWidth < 479 ? 0.25 : window.innerWidth < 991 ? 0.5 : 1;
        let marqueeSpeed = marqueeSpeedAttr * (marqueeContent.offsetWidth / window.innerWidth) * speedMultiplier;
        // Precompute styles for the scroll container
        marqueeScroll.style.marginLeft = `${scrollSpeedAttr * -1}%`;
        marqueeScroll.style.width = `${scrollSpeedAttr * 2 + 100}%`;
        // Duplicate marquee content
        if (duplicateAmount > 0) {
            const fragment = document.createDocumentFragment();
            for(let i = 0; i < duplicateAmount; i++)fragment.appendChild(marqueeContent.cloneNode(true));
            marqueeScroll.appendChild(fragment);
        }
        // GSAP animation for marquee content
        const marqueeItems = marquee.querySelectorAll("[data-marquee-collection-target]");
        const animation = gsap.to(marqueeItems, {
            xPercent: -100,
            repeat: -1,
            duration: marqueeSpeed,
            ease: "linear"
        }).totalProgress(0.5);
        // Initialize marquee in the correct direction
        gsap.set(marqueeItems, {
            xPercent: marqueeDirectionAttr === 1 ? 100 : -100
        });
        animation.timeScale(marqueeDirectionAttr); // Set correct direction
        animation.play(); // Start animation immediately
        // Set initial marquee status
        marquee.setAttribute("data-marquee-status", "normal");
        // ScrollTrigger logic for direction inversion
        ScrollTrigger.create({
            trigger: marquee,
            start: "top bottom",
            end: "bottom top",
            onUpdate: (self)=>{
                const isInverted = self.direction === 1; // Scrolling down
                const currentDirection = isInverted ? -marqueeDirectionAttr : marqueeDirectionAttr;
                // Update animation direction and marquee status
                animation.timeScale(currentDirection);
                marquee.setAttribute("data-marquee-status", isInverted ? "normal" : "inverted");
            }
        });
        // Extra speed effect on scroll
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: marquee,
                start: "0% 100%",
                end: "100% 0%",
                scrub: 0
            }
        });
        const scrollStart = marqueeDirectionAttr === -1 ? scrollSpeedAttr : -scrollSpeedAttr;
        const scrollEnd = -scrollStart;
        tl.fromTo(marqueeScroll, {
            x: `${scrollStart}vw`
        }, {
            x: `${scrollEnd}vw`,
            ease: "none"
        });
    });
}
// Initialize Marquee with Scroll Direction
document.addEventListener("DOMContentLoaded", ()=>{
    $cd63440b1507af0d$var$initMarqueeScrollDirection();
});

})();
//# sourceMappingURL=marquee.js.map
